import getOneBundle, {BUNDLE_SMALL_NAME} from "../../BundleResourceConfig";
import data_control from "../../../../engines/libs/data_control";
import { getOneHeadUrlById } from "../../config/UserHeadConfig";
import O1HD from "../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;
/**
 *
 */
@ccclass
export default class RankItemNode extends cc.Component {

    @property({type:cc.Sprite})
    itemBgSpirit : cc.Sprite = null;
    @property({type:cc.Label,displayName:"排序下标"})
    lbIndex : cc.Label = null;
    @property({type:cc.Sprite,displayName:'头像'})
    headSpirit : cc.Sprite = null;
    @property({type:cc.Label,displayName:"用户昵称"})
    lbUserName : cc.Label = null;
    @property({type:cc.Label,displayName:"分数"})
    lbScore : cc.Label = null;

    private mSelfFlag : boolean = false;

    onLoad () {}

    start () {

    }

    async bindData( mSortIndex : number ,uid : string, headImg : string , userName : string , score : number ,scoreType : number , selfFlag : boolean = false ){
        this.lbIndex.string = `${mSortIndex}`;
        this.mSelfFlag = selfFlag;
        if ( this.mSelfFlag ) {
            this.lbIndex.node.color = cc.color(55,83,140 );
        }
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.rankGameBundle );
        //加载头像
        if ( headImg ) {
            if ( headImg.includes("local://") ) {
                bundle.load( `assets/head/${getOneHeadUrlById(headImg.split("://")[1])}` , cc.SpriteFrame , ( error , assets : cc.SpriteFrame )=>{
                    if ( error ) {
                        console.error( `排行榜图片加载错误`,error);
                        return;
                    }
                    this.headSpirit.spriteFrame = assets;
                });
            }else{
                let that = this;
                O1HD.getServices().miniGameSrv.getAppApiInstance().drawUrlImage(  headImg , ( texture : cc.SpriteFrame )=> {
                    that.headSpirit.spriteFrame = texture ;
                });
            }
        }

        let itemBg : string = "normalBg";
        switch ( mSortIndex ) {
            case 1:
                itemBg = "firstBg";
                break;
            case 2:
                itemBg = "secondBg";
                break;
            case 3:
                itemBg = "thirdBg";
                break;
        }
        //切换背景
        bundle.load( `assets/${itemBg}` , cc.SpriteFrame , ( error , assets : cc.SpriteFrame )=>{
            if ( error ) {
                console.error( `排行榜图片加载错误`);
                return;
            }
            this.itemBgSpirit.spriteFrame = assets;
        });


        this.lbUserName.string = `${ !userName ? `游客${uid.substr( uid.length - 6,6)}` : userName }`;
        this.lbScore.string = `${data_control.getShowCoins(score,scoreType)}`;
        if ( mSortIndex <= 3 ) {
             this.lbIndex.node.active = false;
        }
    }



}
